/// <reference path="DOMAttached.js" />
/// <reference path="../../../gulp/node_modules/soundmanager2/script/soundmanager2-nodebug.js" />

var PlayPauseButtonInstance = null;

// Currently we only support having ONE PlayPauseButton on the whole site. 
class PlayPauseButton extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		PlayPauseButtonInstance = this;
		this.imgPlay = document.getElementById(options.playButton);
		this.imgPause = document.getElementById(options.pauseButton);

		if (options.soundUrl != null) {
			this.soundUrl = options.soundUrl;
		}

		this.autoplay = options.autoplay;
		this.playInfinite = options.playInfinite;
		var finishInitialization = function() {
			this.safeObserve(this.imgPlay, 'click', this.play.bind(this, this.playInfinite));
			this.safeObserve(this.imgPause, 'click', this.pause.bind(this));

			if (this.soundUrl != null) {
				this.setSoundUrl(this.soundUrl, this.autoplay, this.playInfinite);
			}
		}

		if (soundManager.ok()) {
			finishInitialization();
		} else {
			soundManager.onready(finishInitialization);
		}
	}

	play(infinitely) {
		this.displayPauseButton();
		if (infinitely) {
			this.playInfinitely(this);
		} else {
			this.playOnce(this);
		}
	}

	playInfinitely(obj) {
		if (!obj.sound || !obj.sound.id) {
			return;
		}

		soundManager.play(obj.sound.id, {
			onfinish: function() {
				obj.delayedPlay = setTimeout(function() { obj.playInfinitely(obj) }, 1800);
			}
		});
	}

	playOnce(obj) {
		if (!obj.sound || !obj.sound.id) {
			return;
		}

		soundManager.play(obj.sound.id, {
			onfinish: function() {
				obj.displayPlayButton();
			}
		});
	}

	pause() {
		if (!this.sound || !this.sound.id) {
			return;
		}

		if (this.delayedPlay) {
			clearTimeout(this.delayedPlay);
		}
		this.displayPlayButton();
		var soundId = this.sound.id;
		soundManager.pause(soundId);
	}

	displayPlayButton() {
		this.imgPlay.style.display = 'block';
		this.imgPause.style.display = 'none';
	}

	displayPauseButton() {
		this.imgPause.style.display = 'block';
		this.imgPlay.style.display = 'none';
	}

	createSound(soundUrl) {
		return soundManager.createSound({ id: 'sound', url: soundUrl });
	}

	setSoundUrl(soundUrl, autoplay, repeatInfinitely) {
		if (!soundUrl) {
			return;
		}

		soundManager.destroySound('sound');
		this.soundUrl = soundUrl;
		this.sound = this.createSound(soundUrl);
		if (autoplay) {
			this.play(repeatInfinitely);
		} else {
			this.pause();
		}
	}
}
